import type React from 'react';
import { Suspense } from 'react';

import { SearchLoadingSkeleton } from '@xing-com/crate-search-utils';

import { Container } from './container';
export const Component: React.FC = () => (
  <Suspense fallback={<SearchLoadingSkeleton />}>
    <Container />
  </Suspense>
);
